import CheckmarkIcon from '@ordr-as/icons/CheckmarkIcon';
import type { ExpoChipState } from '../types';

const CHIP_CLASSES: Record<ExpoChipState, string> = {
  DONE: 'bg-green-lightest text-green-darkest',
  ONGOING: 'bg-yellow-lightest text-brand-secondary',
  TODO: 'bg-grey-lightest text-grey-dark',
};

type Props = {
  label: string;
  state: ExpoChipState;
};

const StationChip = ({ label, state }: Props) => (
  <span
    className={`inline-flex items-center gap-1 text-extra-small font-semibold px-2 py-0.5 rounded-full border border-brand-white ${CHIP_CLASSES[state]}`}
  >
    {state === 'DONE' && <CheckmarkIcon width={10} height={10} />}
    {label}
    {state === 'ONGOING' && (
      <span className="kds-chip-dots inline-flex items-center gap-0.5 ml-0.5" aria-hidden="true">
        <span className="w-0.5 h-0.5 rounded-full bg-current opacity-30" />
        <span className="w-0.5 h-0.5 rounded-full bg-current opacity-30" />
        <span className="w-0.5 h-0.5 rounded-full bg-current opacity-30" />
      </span>
    )}
  </span>
);

export default StationChip;
